import gql from 'graphql-tag';

export const PAYMENT_QUERY_GET_ACTIVE_SHOOTERS_JOURNAL_SUBSCRIPTIONS_COUNT = gql`
  query getActiveShootersJournalSubscriptionsCount(
    $createdLastNumberOfDays: Int
  ) {
    getActiveShootersJournalSubscriptionsCount(
      createdLastNumberOfDays: $createdLastNumberOfDays
    ) {
      status
      data
      error {
        message
        code
      }
    }
  }
`;
